/**
 * نگه داشتن صفحه روشن حین جلسهٔ تمرکز.
 * روی همهٔ مرورگرها نیست و بی‌سروصدا شکست می‌خورد — تایمر به آن وابسته نیست،
 * چون زمان از ساعت دیوار می‌آید. این فقط راحتی کاربر است.
 */
interface WakeLockSentinelLike { released: boolean; release(): Promise<void>; }

let sentinel: WakeLockSentinelLike | null = null;

export async function acquire(): Promise<void> {
  try {
    const nav = navigator as Navigator & {
      wakeLock?: { request(type: "screen"): Promise<WakeLockSentinelLike> };
    };
    if (!nav.wakeLock) return;
    sentinel = await nav.wakeLock.request("screen");
  } catch { /* اجازه داده نشد یا پشتیبانی نمی‌شود */ }
}

export async function release(): Promise<void> {
  try {
    await sentinel?.release();
  } catch { /* نادیده */ }
  sentinel = null;
}

/** بعد از برگشتن به تب، قفل باید دوباره گرفته شود */
export function reacquireOnVisible(shouldHold: () => boolean): () => void {
  const onVis = () => {
    if (document.visibilityState === "visible" && shouldHold() && (!sentinel || sentinel.released)) {
      void acquire();
    }
  };
  document.addEventListener("visibilitychange", onVis);
  return () => document.removeEventListener("visibilitychange", onVis);
}
